import React from 'react';
import RegistrationForm from "./components/RegistrationForm";


const App = () => {
  return (
      <RegistrationForm/>
  );
};

export default App;